export default __webpack_public_path__ + "static/students-playing-7da07cc09a12b931641a5d027d07c4b7.jpg";